import React, { useState, useEffect, useRef } from 'react'
import { Modal, message, Form, Input, Radio } from 'antd';
import { useQiyeUpdateQuery, useQiyeUpdateSaveMutation } from '../../store/dianshangtaizhangApi';

import {EditOutlined,} from '@ant-design/icons';

function FirmEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);    
    const { data, isSuccess } = useQiyeUpdateQuery(
        { qy_id: props.qy_id }, 
        { skip: !open }
    );
    
    const [updateSave] = useQiyeUpdateSaveMutation();

    const [info, setInfo] = useState({
        qy_name: '',
        qy_state: '正常',
    }); 

    const editForm = useRef();

    useEffect(() => {
        if (isSuccess && data) {
            if (data.Status === 'success') {     
                console.log(data.Result);           
                editForm.current.setFieldsValue({
                    qy_name: data.Result.qy_name,
                    qy_state: data.Result.qy_state,
                });
                
                setInfo(prevState => ({
                    ...prevState,
                    qy_name: data.Result.qy_name,                              
                    qy_state: data.Result.qy_state,             
                }));
            }
        }
    }, [data, isSuccess,editForm]);

    const handleSubmit = async () => {
        try {
            const result = await updateSave({              
                "qy_id": props.qy_id,
                "qy_name": info.qy_name,
                "qy_state": info.qy_state,
                "qy_uid": localStorage.getItem('eu_id'),
                "qy_uname": localStorage.getItem('eu_name'),
                'qy_report_template':'x',
                'qy_approve_rule':'x',
            }).unwrap();

            if (result.Status === 'success') {
                message.success('修改成功！');
                form.resetFields();
                setOpen(false);
            } else {
                message.error('修改失败！' + result.Message);
            }
        } catch (error) {
            if (error.errorFields) {
                message.error('请检查表单填写是否正确');
            } else {
                message.error('修改失败！' + (error.data?.Message || error.message));
            }
        }
    };

    return (
        <>
            <a onClick={() => { setOpen(true) }}><EditOutlined /> 修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改企业'
                okText="提交"
                cancelText="取消"
                onCancel={() => { setOpen(false); }}
                onOk={handleSubmit}
            >
                <Form
                    form={form}
                    layout="horizontal"
                    name="form_client_edit"
                    initialValues={{ modifier: 'public' }}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <Form.Item name="qy_name" label='名称' wrapperCol={{span:10}} required>
                        <Input 
                            onChange={(e) => {
                                setInfo(prevState => ({...prevState, qy_name: e.target.value}))
                            }}
                        />
                    </Form.Item>                   
                    <Form.Item name="qy_state" wrapperCol={{span:10}} required label='状态'>                        
                       <Radio.Group onChange={(e) => {
                            setInfo(prevState => ({...prevState, qy_state: e.target.value}))
                        }}>
                            <Radio value={'正常'}>正常</Radio>
                            <Radio value={'禁用'}>禁用</Radio>
                        </Radio.Group>
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default FirmEdit